import { V2ThemeProvider } from '@onevision-resources/design-theme';
import { useMemo } from 'react';
import { EllipsesMenu } from 'src/components';
import { gql } from 'src/gql';
import { Address, Conversation } from 'src/graphql';
import { useClientActions } from './use-client-actions';

// ClientMenu reads no fields itself; this fragment exists so parents rendering
// <ClientMenu /> can spread it and transitively fetch what useClientActions needs.
export const ClientMenuFragment = gql(`
  fragment ClientMenu_Client on Client {
    id
    ...UseClientActions_Client
  }
`);

export const ClientMenu = ({
  address,
  clientId,
  conversation,
}: {
  clientId: string;
  address?: Partial<Address>;
  conversation?: Conversation;
}) => {
  const {
    updateClient,
    copyClientId,
    copyClientUrl,
    copyTOS,
    disassociateClient,
    mergeClients,
    deleteClient,
    restoreClient,
  } = useClientActions({
    clientId,
    address,
    conversation,
  });

  const menuOptions = useMemo(
    () =>
      [
        updateClient,
        mergeClients,
        copyClientId,
        copyClientUrl,
        copyTOS,
        restoreClient,
        disassociateClient,
        deleteClient,
      ]
        .filter((option) => ('isAllowed' in option ? option.isAllowed : true))
        .map((option) => ({
          ...option,
          onClick: option.handler,
        })),
    [
      updateClient,
      disassociateClient,
      mergeClients,
      copyClientId,
      copyClientUrl,
      copyTOS,
      deleteClient,
      restoreClient,
    ],
  );

  if (!menuOptions.length) {
    return null;
  }

  return (
    <V2ThemeProvider>
      <EllipsesMenu
        options={menuOptions}
        icon="more-vertical"
        iconLibrary="lucide"
        triggerTestId="client-menu-trigger"
      />
    </V2ThemeProvider>
  );
};
